{
  "name": "terms-conditions-dispatcher",
  "version": "1.0.3-snapshot-20261006-085841",
  "license": "MIT",
  "type": "module",
  "private": true,
  "scripts": {
    "start": "nx serve --open",
    "build": "nx build",
    "build:prod": "nx build --configuration=production",
    "build:dev": "nx build --configuration=dev",
    "build:test": "nx build --configuration=test",
    "lint": "nx lint",
    "test": "nx lint && nx test --configuration=test",
    "watch": "nx test --configuration=test --browsers ChromeHeadless --watch --code-coverage",
    "e2e": "nx e2e",
    "format:write": "prettier **/* --write",
    "format:check": "prettier **/* --list-different",
    "analyze": "yarn run build:prod -- --stats-json && webpack-bundle-analyzer ./dist/terms-conditions-dispatcher/stats-es2015.json",
    "prepare": "husky"
  },
  "dependencies": {
    "@angular/animations": "22.1.8",
    "@angular/cdk": "22.1.8",
    "@angular/common": "22.1.8",
    "@angular/compiler": "22.1.8",
    "@angular/core": "22.1.8",
    "@angular/elements": "22.1.8",
    "@angular/forms": "22.1.8",
    "@angular/material": "22.1.8",
    "@angular/platform-browser": "22.1.8",
    "@angular/platform-browser-dynamic": "22.1.8",
    "@angular/router": "22.1.8",
    "@fortawesome/angular-fontawesome": "5.1.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@fortawesome/fontawesome-svg-core": "^6.6.0",
    "@fortawesome/free-brands-svg-icons": "^6.6.0",
    "@fortawesome/free-regular-svg-icons": "^6.6.0",
    "@fortawesome/free-solid-svg-icons": "^6.6.0",
    "@ng-select/ng-select": "24.2.0",
    "@ngrx/effects": "22.0.1",
    "@ngrx/entity": "22.0.1",
    "@ngrx/router-store": "22.0.1",
    "@ngrx/store": "22.0.1",
    "@ngrx/store-devtools": "22.0.1",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@primeng/themes": "^19.1.0",
    "@swimlane/ngx-datatable": "25.1.0",
    "bootstrap": "^5.3.6",
    "keycloak-angular": "22.0.0",
    "keycloak-js": "^26.1.0",
    "mdb-angular-ui-kit": "11.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.8.0",
    "uuid": "^10.0.0",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.1.9",
    "@angular-devkit/core": "22.1.9",
    "@angular-devkit/schematics": "22.1.9",
    "@angular/compiler-cli": "22.1.8",
    "@angular/language-service": "22.1.8",
    "@babel/core": "^7.26.8",
    "@babel/plugin-proposal-class-static-block": "^7.21.0",
    "@babel/plugin-syntax-class-static-block": "^7.14.5",
    "@babel/preset-env": "^7.26.8",
    "@eslint/js": "^9.8.0",
    "@nx/angular": "23.2.1",
    "@nx/eslint": "23.2.1",
    "@nx/eslint-plugin": "23.2.1",
    "@nx/jest": "23.2.1",
    "@nx/js": "23.2.1",
    "@nx/vite": "23.2.1",
    "@nx/vitest": "23.2.1",
    "@nx/workspace": "23.2.1",
    "@schematics/angular": "22.1.9",
    "@types/jest": "30.0.0",
    "@types/node": "^22.7.9",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "angular-eslint": "22.5.0",
    "codelyzer": "^6.0.2",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^9.0.0",
    "express": "^4.21.1",
    "husky": "^9.1.6",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-preset-angular": "^17.0.1",
    "jest-util": "30.5.1",
    "jiti": "^2.4.2",
    "lint-staged": "^16.0.0",
    "nx": "23.2.1",
    "prettier": "^3.3.3",
    "rimraf": "^6.0.1",
    "ts-node": "~10.9.2",
    "tslint": "~6.1.3",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.33.1",
    "url-loader": "^4.1.1",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
